module.exports = [["AOI","Ancona"],["BDS","Brindisi"],["BLQ","Bologna"],["BRI","Bari"],["CAG","Cagliari"],["CTA","Catania"],["FLR","Firenze"],["GOA","Genova"],["MIL","Milano (tutti gli aereoporti)"],["BGY","Milano (Orio Al Serio)"],["LIN","Milano (Linate)"],["MXP","Milano (Malpensa)"],["NAP","Napoli"],["OLB","Olbia"],["PMO","Palermo"],["PSA","Pisa"],["REG","Reggio Calabria"],["ROM","Roma (tutti gli aereoporti)"],["CIA","Roma (Ciampino)"],["FCO","Roma (Fiumicino)"],["SUF","Lamezia Terme"],["TPS","Trapani"],["TRN","Torino"],["TRS","Trieste"],["VCE","Venezia"],["VRN","Verona"]]


//////////////////
// WEBPACK FOOTER
// ./src/projects/bali/front/configs/types/aereoporti.json
// module id = xEoe
// module chunks = 9